// import REST, { GET, POST, PUT, GetRealTree } from "./REST";
import { GET, GetRealTree, PATCH, PUT } from "./RealtimeDatabase";
import { getDatabase, ref, child, update, get } from "firebase/database";
const db = getDatabase();

/**
 * Returns array of contracts with users names and skills names (not IDs)
 */
export const GetContractsList = (uid = 0) => {
  const contractsPath = "contracts";
  // TODO: сделать хранение скилов и пользователей в контексте
  return GetRealTree("users").then((users) => {
    return GetRealTree("skills").then((skills) => {
      return GetRealTree("perks").then((perks) => {
        return GetRealTree("claims").then((claims) => {
          return GetRealTree("contracts").then((data) => {
            const items = [];
            for (const key in data) {
              const item = { id: key, ...data[key] };
              item.id = key;

              if (!item.name){
                item.name = item.terms.slice(0,40);
                if(item.terms.length > 40) item.name+="...";

              }
              if (item.party && users[item.party])
                item.partyName = users[item.party].name;

              if (item.rewardperk){
                item.rewardperkName = perks[item.rewardperk].name;
                item.rewardperkIcon = perks[item.rewardperk].icon;
              }
              if (item.rewardskil){
                item.rewardskilName = skills[item.rewardskil].name;
                item.rewardskilIcon = skills[item.rewardskil].icon;
              }
              item.claims = claims[key];
              if (uid) { //TODO уюрать это отсюда! контракты должны грузиться все
                //контракты пользователя
                //TODO: подумать над оптимизацией
                if (item.party && item.party == uid) {
                  items.push(item);
                }
              } else {
                items.push(item);
              }
            }
            return items;
          });
        });
      });
    });
  });
};

export const GetAdminUid = function () {
  return get(child(ref(db), `admin`)).then((snapshot) => {
    if (snapshot.exists()) {
      return snapshot.val();
    }
  });
};

export const GetUserName = function (uid) {
  if (!uid) return;
  return get(child(ref(db), `users/${uid}/name`)).then((snapshot) => {
    if (snapshot.exists()) {
      return snapshot.val();
    }
  });
};
/**
 * Update name of the user with given uid
 */
export const SetUserName = function (uid, name) {
  if (!uid) return;
  const db = getDatabase();
  const updates = {};
  updates[`users/${uid}/name`] = name;
  return update(ref(db), updates);
};

export const GetUserData = (uid = 0) => {
  if (!uid) return;
  return get(child(ref(db), `users/${uid}`)).then((snapshot) => {
    if (snapshot.exists()) {
      return(snapshot.val());
    }
  });
}
/**
 * Returns array of perks from closed contracts
 */
 export const GetUserPerks = (uid = 0) => {
  if (!uid) return;
  // TODO: сделать хранение скилов и пользователей в контексте
  return GetRealTree(`perks`).then((perks) => {
      return GetRealTree("contracts").then((contracts) => {
        const items = [];
        const items2map = [];
        // const newitems
        for (const id in contracts) {
          const contract = contracts[id];

          if (
            contract.rewardperk &&
            contract['party'] == uid &&
            contract['status'] >= 2
          ) {
            if (items[contract.rewardperk]) {
              items[contract.rewardperk].count += 1;
            } else {
              items[contract.rewardperk] = {
                count: 1,
                name: perks[contract.rewardperk].name,
                icon: perks[contract.rewardperk].icon
              };
            }
          }
        }
        for (var id in items) {
          if (items.hasOwnProperty(id)) {
            items2map.push({
              name: items[id].name,
              count: items[id].count,
              icon: items[id].icon,
            });
          }
        }
        return items2map;
      });
  });
};

/**
 * Returns array of skills from closed contracts
 */
export const GetUserSkills = (uid = 0) => {
  if (!uid) return;
  // TODO: сделать хранение скилов и пользователей в контексте
  return GetRealTree(`skills`).then((skills) => {
      return GetRealTree("contracts").then((contracts) => {
        const items = [];
        const items2map = [];
        // const newitems
        for (const id in contracts) {
          const contract = contracts[id];

          if (
            contract.rewardskil &&
            contract['party'] == uid &&
            contract['status'] >= 2
          ) {
            if (items[contract.rewardskil]) {
              items[contract.rewardskil].count += 1;
            } else {
              items[contract.rewardskil] = {
                count: 1,
                name: skills[contract.rewardskil].name,
                icon: skills[contract.rewardskil].icon
              };
            }
          }
        }
        for (var id in items) {
          if (items.hasOwnProperty(id)) {
            items2map.push({
              name: items[id].name,
              count: items[id].count,
              icon: items[id].icon,
              id: id,
            });
          }
        }
        return items2map;
      });
  });
};

/**
 * Returns object of skills from closed contracts
 *  {
 *    id: {name: "skillname", score: 20, icon:"star"}
 *  }
 */
export const GetUserSkillsTree = (uid = 0) => {
  if (!uid) return;
  // TODO: сделать хранение скилов и пользователей в контексте
  return GetUserSkills(uid).then((skillsArray) => {
    const skillsObject = {};

    for (let i = 0; i < skillsArray.length; i++) {
      skillsObject[skillsArray[i].id] = skillsArray[i];
    }
    return skillsObject;
  });

};

/**
 * Returns sum of coins from closed contracts
 */
export const GetUserCoins = (uid = false) => {
  if (!uid) return;
  // TODO: сделать хранение скилов и пользователей в контексте
    return GetRealTree("contracts").then((contracts) => {
      let coins = 0;
      for (const id in contracts) {
        const contract = contracts[id];
        const price = contract.rewardPrice;
        if (
          price &&
          contract['party'] == uid &&
          contract['status'] >= 2
        ) {
          coins += +price;
        }
      }
      return coins;
    });
};

/**
 * update contract status
 */
export function incrementContractStatus(uid, contractId) {
  let status = -1;

  get(child(ref(db), `contracts/${contractId}/status`)).then((snapshot) => {
    if (snapshot.exists()) {
      status = snapshot.val();

      const contractUpdates = {
        status: +status + 1,
        dateUpdated: new Date().getTime(),
      };
      update(child(ref(db), `contracts/${contractId}`), contractUpdates);
    }
  });
}
/**
 * Get claims
 */
export function GetClaimsTree(contractId) {
  return GetRealTree(`claims/${contractId}`);
}

/**
 * Claim a contract
 */
export function ClaimContract(contractId, userId) {
  return PATCH(
    { time: new Date().getTime() },
    `claims/${contractId}/${userId}`
  );
}

/**
 * Get Perks
 */
export function GetPerks() {
  return GET("perks");
}

/**
 * Get Perk by ID
 */
export function GetPerkByID(id) {
  if (id) {
    return get(child(ref(db), `perks/${id}/icon`)).then((snapshot) => {
      if (snapshot.exists()) {
        return snapshot.val();
      }
    });
  }
  return new Promise(() => false);
}

/**
 * Get Skill by ID
 */
export function GetSkillByID(id) {
  if (id) {
    return get(child(ref(db), `skills/${id}/icon`)).then((snapshot) => {
      if (snapshot.exists()) {
        return snapshot.val();
      }
    });
  }
  return new Promise(() => false);
}

/**
 * Get Skill name by ID
 */
 export function GetSkillNameByID(id) {
  if (id) {
    return get(child(ref(db), `skills/${id}/name`)).then((snapshot) => {
      if (snapshot.exists()) {
        return snapshot.val();
      }
    });
  }
  return new Promise(() => false);
}

/**
 * Get Perk Image - OBSOLETE // TODO remove
 */
export function GetPerkImage(i, alt = "icon") {
  const perkImgs = GetPerksFileNames();
  // if (perkImgs.indexOf(i) == -1) return <i>no_image</i>;
  return (
    <img
      src={perkImgs[i]}
      alt={alt}
      title={alt}
      width="24"
      className="perk_icon"
    />
  );
}
/**
 * Get skill Image  - OBSOLETE // TODO remove
 */
export function GetSkillImage(i, alt = "icon") {
  const skillImgs = GetSkillFileNames();
  // if (skillImgs.indexOf(i) == -1) return <i>no_image</i>;
  return (
    <img
      src={skillImgs[i]}
      alt={alt}
      title={alt}
      width="24"
      className="perk_icon"
    />
  );
}
/**
 * GetPerksFileNames
 */
export function GetPerkFileName(i) {
  const perkImgs = GetPerksFileNames();
  return perkImgs[i];
}

/**
 * GetPerksFileNames
 */
export function GetPerksFileNames() {
  return [
    // "baf",
    "cad",
    "3dp",
    "drill",
    "arduino",
    "vector",
    "laser",
    "novator",
    "independent",
    "optimizer",
    "creative",
    "industrial",
    "informator",
    "graphical",
    "teacher",
    "steel",
    "penalty",
    "error",
    "grid",
    "degree",
  ];
}
/**
 * GetSkillFileNames
 */
export function GetSkillFileNames() {
  return [
    "star2",
    "bulp",
    "cog",
    "project",
    "smiley-talk",
  ];
}


